import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Formik } from 'formik';
import * as actions from './redux/actions';
import {
  fieldSchema,
  fieldSchemaValidation,
  fileTypes,
} from '../../common/formElements/CollectionSectionType';
import ProjectOnBoardFieldForm from './ProjectOnBoardFieldForm';
import { FieldTypes } from 'drapcode-constant';
export class AddFieldInCollection extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  state = {
    showFieldType: true,
    selectedField: 'text',
  };

  handleSubmit = (values) => {
    values.type = this.state.selectedField;

    if (values.type === FieldTypes.large_text.id) {
      values.validation = { ...values.validation, max: 1000 };
    }

    const { projectId, collection, actions, version } = this.props;
    actions
      .createField({
        projectId,
        collection,
        version,
        data: values,
      })
      .then((res) => {
        this.setState({ showFieldType: true, selectedField: 'text' });
      });
  };
  changeFieldType = (newField) => {
    this.setState({ selectedField: newField });
  };

  showFieldForm = () => {
    const { selectedField } = this.state;
    const { projectCollections } = this.props.projectOnBoard;
    if (!selectedField) return '';
    return (
      <Formik
        enableReinitialize={true}
        initialValues={fieldSchema()}
        validationSchema={fieldSchemaValidation()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <ProjectOnBoardFieldForm
                values={values}
                setFieldValue={setFieldValue}
                selectedField={selectedField}
                setFieldTouched={setFieldTouched}
                changeFieldType={this.changeFieldType}
              />
            </div>
            <div className="col-md-12 col-lg-12 text-right">
              <button type="submit" className="btn btn-theme-submit" disabled={isSubmitting}>
                <i className="wb webconnect-save-regular"></i>&nbsp;&nbsp;Create Field
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  render() {
    return <div className="mt-3">{this.showFieldForm()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFieldInCollection);
